import { FC } from 'react';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import LocationSvg from '@edikk-edikk/country-layout-black-icon/src/location.svg';
import cardHeaderCss from '#srcCssModules/card/card-header.module.scss';
import cardHeaderIconCss from '#srcCssModules/card/card-header-icon.module.scss';

const CardLocationHeader: FC = () => (
  <div className={cardHeaderCss.cardHeader}>
    <div className={cardHeaderIconCss.cardHeaderIcon}>
      <SvgIcon
        Component={LocationSvg}
        isWithoutStroke
        additionalClassName={cardHeaderIconCss.cardHeaderIcon__content}
      />
    </div>
  </div>
);

export { CardLocationHeader };
